<template>
  <div>
    <b-modal
      v-model="eventsModalVisible"
      title="Wybierz wydarzenia"
      size="full"
      cancel-title="Anuluj"
      ok-title="Skopiuj do fanzone"
      @ok="onEventsSelectionAccept"
    >
      <select-events-list
        @select:events="selectedEvents = $event.selectedEvents"
        :eventsIds="form.mainEventId"
      />
    </b-modal>    

    <b-row class='mb-3'>
      <b-col cols='6'>
        <label>Nazwa</label>
        <b-form-input
          v-model="form.doc.name"
          @input='(e) => actions.handleSimplePropChanged("name", e)'
          placeholder="Nazwa"
          required
        />
      </b-col>
    
      <b-col>
        <label>Status</label>
        <b-form-select
          v-model='form.fanzine_status'
          :options='statusOptions'
          @input='(e) => actions.handleSetData("fanzine_status", e)'
        />
      </b-col>

      <b-col>
        <label>Typ</label>
        <b-form-select
          v-model='form.fanzine_type'
          :options='typeOptions'
          @input='(e) => actions.handleSetData("fanzine_type", e)'
        />
      </b-col>

      <b-col>
        <label>Widoczność</label>
        <b-form-select
          v-model='form.fanzine_visibility'
          :options='visibilityOptions'
          @input='(e) => actions.handleSetData("fanzine_visibility", e)'
        />
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col>
        <b-row>
          <b-col v-for='(locale, i) in locales' :key='i' class='mb-3'>
            <label>Tytuł {{ locale.toUpperCase() }}</label>
            <d-input
              class="mb-2 mr-sm-2 mb-sm-0"
              :value="form.doc.openTitle[locale]"
              @input='(e) => actions.handleSimplePropWithLocaleChanged("openTitle", e, locale)'
              placeholder="Tytuł"
              required
            />
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <b-form-checkbox
              v-model='$store.state.fanzones.form.doc["hideOpenTitle"]'
              @input='(e) => actions.handleSimplePropChanged("hideOpenTitle", e)'
            >
              Ukryj Tytuł 1 w aplikacji
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col v-for='(locale, i) in locales' :key='i'>
            <label>Tytuł 2 {{ locale.toUpperCase() }}</label>
            <d-input
              class="mb-2 mr-sm-2 mb-sm-0"
              :value="form.doc.openDates[locale]"
              @input='(e) => actions.handleSimplePropWithLocaleChanged("openDates", e, locale)'
              placeholder="Daty"
              required
            />
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <b-form-checkbox
              v-model='$store.state.fanzones.form.doc["hideStartEndDates"]'
              @input='(e) => actions.handleSimplePropChanged("hideStartEndDates", e)'
            >
              Ukryj Tytuł 2 w aplikacji
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <b-row>
              <b-col>
                <label>Start</label>
                <datetime
                  :value="form.doc.start"
                  @input='(e) => { actions.handleSimplePropChanged("start", e) }'
                  type="datetime"
                  input-class="form-control"
                  :minute-step="5"
                  value-zone="local"
                />
              </b-col>
              <b-col>
                <label>Koniec</label>
                <datetime
                  :value="form.doc.end"
                  @input='(e) => { actions.handleSimplePropChanged("end", e) }'
                  type="datetime"
                  input-class="form-control"
                  :minute-step="5"
                  value-zone="local"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <b-form-checkbox
              v-model='$store.state.fanzones.form.doc["hideMainMenu"]'
              @input='(e) => actions.handleSimplePropChanged("hideMainMenu", e)'
            >
              Ukryj menu główne aplikacji
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-col>
      
      <b-col cols='6'>
        <b-row class='mb-3'>
          <b-col v-for='(locale, i) in locales' :key='i'>
            <label>Głosowanie info tekst {{ locale.toUpperCase() }}</label>
            <vue-simplemde
              v-model="form.doc.voting.info.text[locale]"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class='mb-3'>
      
      
      
    </b-row>
    <b-row class='mb-3'>
      <b-col cols=6>
        <b-row class='mb-3'>
          <b-col v-if='idStepsEvent'>
            <label>ID eventu dla krokomierza</label>
            <b-form-input
              :value="form.doc.mainEventId"
              @input='(e) => actions.handleSimplePropChanged("mainEventId", e)'
              placeholder="np: 1437"
            />
          </b-col>
          <b-col>
            <label>Link do biletów</label>
            <b-form-input
              :value="form.doc.ticketUrl"
              @input='(e) => actions.handleSimplePropChanged("ticketUrl", e)'
              placeholder="https://..."
              required
            />
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <label>Tagi newsów</label>
            <b-form-input
              :value="form.doc.newsTags"
              @input='(e) => actions.handleSimplePropChanged("newsTags", e)'
              placeholder="tagi oddzielone przecinkami"
              required
            />
          </b-col>
        </b-row>
        <b-row v-if='idsRelatedEvents' class='mb-3'>
          <b-col>
            <label>ID powiązanych eventów oddzielone przecinkami</label>                
            <d-input-group>
              <b-form-input
                class="mr-2"
                :value="form.doc.mainEventId"
                @input='(e) => actions.handleSimplePropChanged("mainEventId", e)'
                placeholder="np: 1437, 1438, 1439"
                @model="(value) => form.mainEventId = value"
              />
              <d-button
                variant='outline-success'
                @click="(e) => handleSelectEvents(e)"
              >Wybierz</d-button>
            </d-input-group>
          </b-col>
        </b-row>
        <b-row class='mb-3'>
          <b-col>
            <label>API timeout (sekundy)</label>
            <b-form-input
              :value="form.doc.apiTimeout"
              @input='(e) => actions.handleSimplePropChanged("apiTimeout", e)'
              type="number"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <label>Dane kontaktowe</label>
            <vue-simplemde
              :value="form.doc.contact"
              @input='(e) => actions.handleSimplePropChanged("contact", e)'
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-checkbox
              v-model='$store.state.fanzones.form.doc["hideContact"]'
              @input='(e) => actions.handleSimplePropChanged("hideContact", e)'
            >
              Ukryj w aplikacji
            </b-form-checkbox>
          </b-col>
        </b-row>  
      </b-col>  
    </b-row>  
  </div>
</template>

<script>
  import selectEventsList from '../../SelectEventsList'

  import {
    FANZONE_STATUS_OPTIONS,
    FANZONE_TYPE_OPTIONS,
    FANZONE_VISIBILITY_OPTIONS,
    LOCALES,
  } from '@/const'

  import {
    handleSetData,
    handleSimplePropChanged,
    handleSimplePropWithLocaleChanged,
  } from '@/store/utils'

  import VueSimplemde from "vue-simplemde";

  export default {
    props: ['idStepsEvent', 'idsRelatedEvents'],
    components: { VueSimplemde, selectEventsList },
    data() {
      return {
        locales: LOCALES,
        eventsModalVisible: false,
        selectedEvents: '',
        actions: {
          handleSetData,
          handleSimplePropChanged,
          handleSimplePropWithLocaleChanged,
        },
        statusOptions: FANZONE_STATUS_OPTIONS,
        typeOptions: FANZONE_TYPE_OPTIONS,
        visibilityOptions: FANZONE_VISIBILITY_OPTIONS,
      }
    },
    methods: {
      handleSelectEvents(e) {
        e.stopPropagation()
        e.preventDefault()
        this.eventsModalVisible = true
      },
      onEventsSelectionAccept() {
        this.actions.handleSimplePropChanged("mainEventId", this.selectedEvents)
        this.form.mainEventId = this.selectedEvents
      },
    },
    computed: {
      form() {
        return this.$store.state.fanzones.form
      }
    },
  }

</script>